import { render, staticRenderFns } from "./SpeechAlert.vue?vue&type=template&id=54bd4f1d&scoped=true&"
import script from "./SpeechAlert.vue?vue&type=script&lang=js&"
export * from "./SpeechAlert.vue?vue&type=script&lang=js&"
import style0 from "./SpeechAlert.vue?vue&type=style&index=0&id=54bd4f1d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd4f1d",
  null
  
)

export default component.exports